export const langTypes = {
    ZH_TW: 'zh-TW',
    ZH_CN: 'zh-CN',
    ZH_HK: 'zh-HK',
    EN_US: 'en-US',
    JA_JP: 'ja',
    PT_BR: 'pt-BR',
    ES_419: 'es-419',
    TH_TH: 'th-TH'
};

export const facebookCommentSdkLangsMapping = {
    [langTypes.ZH_TW]: 'zh_TW',
    [langTypes.ZH_CN]: 'zh_CN',
    [langTypes.ZH_HK]: 'zh_HK',
    [langTypes.EN_US]: 'en_US',
    [langTypes.JA_JP]: 'ja_JP',
    [langTypes.PT_BR]: 'pt_BR',
    [langTypes.ES_419]: 'es_419',
    [langTypes.TH_TH]: 'th_TH'
};

export const promoLangOption = {
    [langTypes.ZH_TW]: 'label.game_lang.zh-TW',
    [langTypes.ZH_CN]: 'label.game_lang.zh-CN',
    [langTypes.EN_US]: 'label.game_lang.en-US',
    [langTypes.JA_JP]: 'label.game_lang.ja',
    [langTypes.PT_BR]: 'label.game_lang.pt-BR',
    [langTypes.ES_419]: 'label.game_lang.es-419',
    [langTypes.TH_TH]: 'label.game_lang.th-TH'
};

export const promoLangOptions = [
    { value: langTypes.ZH_TW, label: 'label.game_lang.zh-TW' },
    { value: langTypes.ZH_CN, label: 'label.game_lang.zh-CN' },
    { value: langTypes.EN_US, label: 'label.game_lang.en-US' },
    { value: langTypes.JA_JP, label: 'label.game_lang.ja' },
    { value: langTypes.PT_BR, label: 'label.game_lang.pt-BR' },
    { value: langTypes.ES_419, label: 'label.game_lang.es-419' },
    { value: langTypes.TH_TH, label: 'label.game_lang.th-TH' }
];
